import { en } from "./en/en";
import { nb } from "./nb/nb";

export const messages = { en, nb };
